import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';
import { ErrorOutline as ErrorIcon } from '@mui/icons-material';
import { useAuth } from '../../context/AuthContext';

interface SessionExpiredDialogProps {
  open: boolean;
  onClose: () => void;
}

/**
 * Reusable dialog component for session expiration
 * Displayed when authentication token is expired or missing
 */
export const SessionExpiredDialog: React.FC<SessionExpiredDialogProps> = ({ open, onClose }) => {
  const { login } = useAuth();

  const handleGoToLogin = async () => {
    onClose();
    // Trigger Authguard login flow
    await login();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <ErrorIcon color="error" />
        <Typography variant="h6">Session Expired</Typography>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" gutterBottom>
          Your authentication session has expired. Please log in again to continue.
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
          You will be redirected to the login page when you click the button below.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          onClick={onClose}
          color="inherit"
        >
          Cancel
        </Button>
        <Button
          onClick={handleGoToLogin}
          variant="contained"
          color="primary"
          autoFocus
        >
          Go to Login
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SessionExpiredDialog;

